export default "__VITE_ASSET__8802e286__"